export default __webpack_public_path__ + "static/growingBussinessBg-f445c7434db5a17ae573714f4c9463aa.png";